import { FunctionComponent } from 'react'
import styles from './planningKPI.module.scss'
import Indicator from '@/components/_custom/Indicator/indicator.tsx'
import { useTranslation } from 'react-i18next'

interface GlobalKPIProps {
    successRate: number
    warningRate: number
    errorRate: number
    isParent: boolean
}

const GlobalKPI: FunctionComponent<GlobalKPIProps> = ({
    successRate,
    warningRate,
    errorRate,
    isParent
}: GlobalKPIProps) => {
    const { t } = useTranslation()

    return (
        <>
            <a className={styles.IndicatorNoClickable}>
                <Indicator
                    count={successRate}
                    parent={isParent}
                    size={'m'}
                    text={successRate > 1 ? t('hoursValidated') : t('hourValidated')}
                    className={styles.Indicator}
                    badge={'booked'}
                />
            </a>
            <a className={styles.IndicatorNoClickable}>
                <Indicator
                    count={warningRate}
                    parent={isParent}
                    size={'m'}
                    text={warningRate > 1 ? t('hoursToValidate') : t('hourToValidate')}
                    className={styles.Indicator}
                    badge={'warning'}
                />
            </a>
            <a className={styles.IndicatorNoClickable}>
                <Indicator
                    count={errorRate}
                    parent={isParent}
                    size={'m'}
                    text={errorRate > 1 ? t('hoursNotValidated') : t('hourNotValidated')}
                    className={styles.Indicator}
                    badge={'error'}
                />
            </a>
        </>
    )
}

export default GlobalKPI
